"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _helpers = require("../helpers");
var _misc = require("../../misc");
var _FormulaMember = _interopRequireDefault(require("../FormulaMember"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StyledMinimum = _styledComponents["default"].div.withConfig({
  displayName: "Minimum__StyledMinimum",
  componentId: "sc-1kk027g-0"
})(["", ""], function (props) {
  var spacing = props.theme.spacing;
  return (0, _styledComponents.css)(["margin-bottom:", ";"], spacing.tiny);
});
StyledMinimum.displayName = 'StyledMinimum';
var Minimum = function Minimum(_ref) {
  var disabled = _ref.disabled,
    rule = _ref.rule,
    errors = _ref.errors,
    labels = _ref.labels,
    getFormulaOperandValues = _ref.getFormulaOperandValues,
    ruleIndex = _ref.ruleIndex,
    formulaOperators = _ref.formulaOperators,
    ruleChange = _ref.ruleChange,
    formulaOtherProps = _ref.formulaOtherProps;
  var activeType = rule.complex.activeType;
  var minPath = ['complex', activeType, 'minimum'];
  var minFormula = R.path(minPath, rule);
  return /*#__PURE__*/_react["default"].createElement(StyledMinimum, {
    "data-testid": "minimum-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_misc.Paragraph, null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _utils.toUpper)(labels.FORMULA_RANGE_MINIMUM))), minFormula.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_FormulaMember["default"], _extends({
      labels: labels,
      errors: R.path(minPath, errors),
      disabled: disabled,
      formulaOperators: formulaOperators,
      member: item,
      key: item.key,
      elementKey: item.key,
      keysPath: [index],
      ruleIndex: ruleIndex,
      noDelete: R.length(minFormula) === 1,
      actions: _objectSpread(_objectSpread({}, (0, _helpers.getFormulaActions)('complex', minFormula, ruleChange, {
        rule: rule,
        key: 'minimum'
      })), {}, {
        getFormulaOperandValues: getFormulaOperandValues
      })
    }, formulaOtherProps));
  }));
};
Minimum.defaultProps = {
  disabled: false,
  errors: {},
  formulaOperators: [],
  formulaOtherProps: {}
};
Minimum.propTypes = {
  disabled: _propTypes["default"].bool,
  ruleIndex: _propTypes["default"].number.isRequired,
  rule: _propTypes["default"].shape({
    complex: _propTypes["default"].shape({
      activeType: _propTypes["default"].string
    })
  }).isRequired,
  errors: _propTypes["default"].shape({}),
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  formulaOtherProps: _propTypes["default"].shape({}),
  getFormulaOperandValues: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = Minimum;